<template>
  <div class="about-swiper-it">
    <swiper ref="mySwiper" :options="swiperOptions" class="about-swiper-container pc">
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片2.png" alt="">
          <img src="@/assets/partner/图片19.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片17.png" alt="">
          <img src="@/assets/partner/图片20.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片4.png" alt="">
          <img src="@/assets/partner/图片5.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片30.png" alt="">
          <img src="@/assets/partner/图片26.png" alt="">
        </div>
      </swiper-slide>
    </swiper>
    <swiper ref="mySwiper2" :options="swiper2Options" class="about-swiper-container mobile">
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片2.png" alt="">
          <img src="@/assets/partner/图片19.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片17.png" alt="">
          <img src="@/assets/partner/图片20.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片4.png" alt="">
          <img src="@/assets/partner/图片5.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片30.png" alt="">
          <img src="@/assets/partner/图片26.png" alt="">
        </div>
      </swiper-slide>
    </swiper>
  </div>

</template>

<script>
export default {
  name: "intro-swiper",
  data() {
    return {
      swiperOptions: {
        speed: 4000,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {delay: 0, disableOnInteraction: false},
        breakpoints: {
          640: {slidesPerView: 3, spaceBetween: 0},
        },
      },
      swiper2Options: {
        speed: 4000,
        slidesPerView: 2,
        spaceBetween: 0,
        loop: true,
        autoplay: {delay: 0, disableOnInteraction: false},
        breakpoints: {
          640: {slidesPerView: 3, spaceBetween: 0},
        },
      }
    };
  },
  mounted() {
    // 确保DOM渲染后初始化（静态数据）
    this.$nextTick(() => {
      if (this.$refs.mySwiper) {
        this.$refs.mySwiper.$swiper.update();  // 强制更新
        this.$refs.mySwiper.$swiper2.update();  // 强制更新
      }
    });
  }
}
</script>

<style lang="scss">
.about-swiper-it {
  padding-top: 40px;
  padding-bottom: 40px;
  .swiper-container {
    height: 100px;
  }
}

.patter-images {
  display: flex;
  padding: 10px;
  justify-content: space-between;
  img {
    width: 140px;
    height: 60px;
    background: #ffffff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 10px 20px;
    -o-object-fit: contain;
    object-fit: contain;
    border-radius: 5px;
  }
}


.swiper-wrapper {
  transition-timing-function:linear;
}

.about-swiper-container {
  width: 100%;
  height: 100%;
  position: relative;
  //&:before {
  //    content: '';
  //    width: 100%;
  //    height: 400px;
  //    background: rgba(0, 0, 0, 0.5);
  //    z-index: 2;
  //    position: absolute;
  //    top: 0;
  //    left: 0;
  //}
}
@media (max-width: 768px) {
  .about-swiper-it .about-swiper-container.mobile .patter-images {
    display: flex;
    justify-content: space-between;
    padding: 0;
    img {
      width: 50px;
      height: 20px;
      display: block;
      margin: 0 auto 20px auto;
      padding: 10px 5px;
    }
  }
}
.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  //object-position: 10% 30%;
}
</style>
